import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\node_modules\\next-intl\\dist\\esm\\production\\navigation\\shared\\BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["BookingForm"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\src\\components\\booking\\BookingForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookOrgTabs"] */ "C:\\Users\\sargism\\GIT\\Welcomehouse\\src\\components\\booking\\BookOrgTabs.tsx");
